import React from 'react'

function VariableFundDisclosure({ fundName }) {
  let date = null
  const cleanFund = fundName?.replace('- ', '').toLowerCase().trim()

  switch (cleanFund) {
    case 'columbia variable portfolio strategic income fund':
      date = '8/29/2014'
      break
    case 'columbia variable portfolio u.s. government mortgage fund':
      date = 'May 2013'
      break
    default:
      date = null
  }
  return (
    date && (
      <p className="Disclaimer-text">
        Performance prior to {date} reflects a different investment strategy.
      </p>
    )
  )
}

export default VariableFundDisclosure
